// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Misma clase que Cuadro de Mando; sin scoped porque el tooltip se monta en body. */
.tooltip-ancho .tooltip-inner {
  max-width: 500px !important;
  text-align: left !important;
  width: max-content;
  white-space: pre-line;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Dashboard.vue"],"names":[],"mappings":";AA2gBA,oFAAoF;AACpF;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["\n/* Misma clase que Cuadro de Mando; sin scoped porque el tooltip se monta en body. */\n.tooltip-ancho .tooltip-inner {\n  max-width: 500px !important;\n  text-align: left !important;\n  width: max-content;\n  white-space: pre-line;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
